export default __webpack_public_path__ + "static/media/gates.7edd5fea.jpg";